import { render } from "./prueba_login.vue?vue&type=template&id=7b9fa7e0&scoped=true"
import script from "./prueba_login.vue?vue&type=script&lang=js"
export * from "./prueba_login.vue?vue&type=script&lang=js"

import "./prueba_login.vue?vue&type=style&index=0&id=7b9fa7e0&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9fa7e0"]])

export default __exports__